export const QUERY_STRING_PREV_STEP_OVERRIDE: string = 'mockPreviousStep';
